import { render, staticRenderFns } from "./ImporterAlert.vue?vue&type=template&id=45d52ed3"
import script from "./ImporterAlert.vue?vue&type=script&lang=js"
export * from "./ImporterAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports